var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBulkMove = function SvgBulkMove(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M3.99 12.242a.99.99 0 1 0 0 1.979h5.655l-1.527 1.525c-.406.407-.422 1.05-.036 1.436.387.386 1.03.37 1.437-.036l3.135-3.132.019-.023.018-.021.016-.014.016-.012c.387-.387.366-1.034-.047-1.446L9.498 9.323c-.412-.412-1.06-.432-1.447-.047-.387.387-.365 1.034.047 1.446l1.52 1.52zm4-7a.99.99 0 1 0 0 1.979h5.655l-1.527 1.525c-.406.407-.423 1.05-.036 1.436s1.03.37 1.437-.036l3.135-3.132.019-.023.018-.021.016-.014.016-.012c.387-.387.366-1.034-.047-1.446l-3.178-3.175c-.412-.412-1.06-.432-1.447-.047-.387.387-.365 1.034.046 1.446l1.522 1.52z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBulkMove);
export default ForwardRef;